import b64toBlob from 'b64-to-blob';

export const generatePdfThumbnail = (data, callback, fileDataS3) => {
  pdfjsLib.getDocument(data).promise.then((pdf_doc) => {
    pdf_doc.getPage(1).then((page) => {
      var canvas = document.createElement('canvas');
      canvas.style.visibility = 'hidden';
      canvas.style.height = '0px';
      document.body.appendChild(canvas);

      var scale = canvas.width / page.getViewport(1).width;
      var viewport = page.getViewport({scale});
      var context = canvas.getContext('2d');

      // Set canvas height
      canvas.height = viewport.height;

      // Render PDF page into canvas context
      var renderContext = {
        canvasContext: context,
        viewport: viewport
      };
      page.render(renderContext).then(() => {
        const contentType = 'image/png';

        const b64Data = canvas.toDataURL().replace('data:image/png;base64,', '');

        const blob = b64toBlob(b64Data, contentType);

        // const blobUrl = URL.createObjectURL(blob);

        callback(blob, fileDataS3);

        // const x = document.createElement('IMG');
        // x.setAttribute('src', blobUrl);
        // x.style.marginLeft = '400px';
        // x.setAttribute('alt', 'The Pulpit Rock');
        // document.body.appendChild(x);
      });
    });
  }).catch((error) => {
    console.log('error', error.message);
  });
};



// WEBPACK FOOTER //
// ./src/helper/generate-pdf-thumbnail.js